import { useAtom } from 'jotai'
import { Languages } from '../locale'
import { createAtom } from './atomFactory'
import { MMKVKey } from '../mmkv'

const { atom, resetAtom } = createAtom<Languages>(Languages.en_US, MMKVKey.Locale)

export const useLocaleAtom = () => useAtom(atom)
export const useResetLocaleAtom = () => useAtom(resetAtom)
